import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SendContactMessage } from "../../Api/SendContactMessage";

export default function Contact() {
  const { handleSubmit, handleChange, handleBlur, touched, values, errors } =
    useFormik({
      initialValues: {
        Name: "",
        Email: "",
        Message: "",
      },
      validationSchema: Yup.object({
        Name: Yup.string().min(5).required("Name required!"),
        Email: Yup.string().email().required("Email required!"),
        Message: Yup.string().min(40).required("Message required!"),
      }),
      onSubmit: async (values) => {
        const { data } = await SendContactMessage(values);
        if (data.status === true) {
          Swal.fire("Contact Successful!", `${data.msg}`, "success");
        } else {
          Swal.fire("Contact Failed!", `${data.msg}`, "error");
        }
      },
    });

  return (
    <>
      <div className="w-full h-4/6 md:max-w-full mx-auto">
        <div className="p-6 border sm:rounded-md">
          <form onSubmit={handleSubmit}>
            <label className="block mb-6">
              <span className="text-gray-700">Your name</span>
              <input
                onChange={handleChange}
                value={values.Name}
                onBlur={handleBlur}
                name="Name"
                type="text"
                className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                placeholder="Joe Bloggs"
              />
              {touched.Name && errors.Name && (
                <span className="text-red-500 py-2">{errors.Name}</span>
              )}
            </label>
            <label className="block mb-6">
              <span className="text-gray-700">Email address</span>
              <input
                onChange={handleChange}
                value={values.Email}
                onBlur={handleBlur}
                name="Email"
                type="email"
                className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                placeholder="joe.bloggs@example.com"
                required
              />
              {touched.Email && errors.Email && (
                <span className="text-red-500 py-2">{errors.Email}</span>
              )}
            </label>
            <label className="block mb-6">
              <span className="text-gray-700">Message</span>
              <textarea
                onChange={handleChange}
                value={values.Message}
                onBlur={handleBlur}
                name="Message"
                className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                rows="3"
                placeholder="Tell us what you're thinking about..."
              ></textarea>
              {touched.Message && errors.Message && (
                <span className="text-red-500 py-2">{errors.Message}</span>
              )}
            </label>
            <div className="mb-6">
              <button
                type="submit"
                className="
            h-10
            px-5
            text-white
            bg-[#3742fa]
            rounded-lg
            transition-colors
            duration-150
            focus:shadow-outline
            hover:bg-[#5352ed]
          "
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
